// extracted by mini-css-extract-plugin
module.exports = {"goodChoice":"PlayGame_goodChoice__ciurZ","badChoice":"PlayGame_badChoice__2h0QZ"};